// extracted by mini-css-extract-plugin
var _1 = "SubMenuFoldersSection-moduleSubMenuFoldersSection__NuuPr";
export { _1 as "SubMenuFoldersSection" }
